import styled from "styled-components";

import { windowWidth } from "@styles/global";

const FormContainer = styled.form`
  overflow-y: auto;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-top: 7px;
  padding-bottom: 20px;

  @media (max-width: ${windowWidth.tablet}) {
    width: 100%;

    ::-webkit-scrollbar {
      width: 1px;
    }
  }

  .MuiAutocomplete-root {
    width: 440px;
    min-height: 65px;

    @media (max-width: ${windowWidth.tablet}) {
      width: 100%;
    }
  }
`;

export { FormContainer };
